import apiServices from "../../../../../services/apiServices";
// import router from "../../router";
import eventBus from "../../../../main";
// import router from "@/router";
//import jwtDecode from "jwt-decode";

export default {
  state: {
    buyer: {
      product: "",
      price: "",
      entity: "",
      reference: "",
      pos: "",
      refOrigin: "",
      email: "",
      payType: "",
      cellphone: "1N-AN-1H",
      productUUID: "",
      productCategoryName: "",
      productCategoryUUID: "",
      recharge: "",
      description: ""
    },
    data: Object
  },
  mutations: {
    SET_BUYER_ENTITY(state, value) {
      state.buyer.product = value.product;
      state.buyer.price = value.price;
      state.buyer.entity = value.entity;
      state.buyer.refOrigin = value.refOrigin;
      state.buyer.productUUID = value.productUUID;
      state.buyer.productCategoryName = value.productCategoryName;
      state.buyer.productCategoryUUID = value.productCategoryUUID;
      state.buyer.recharge = value.recharge;
      // state.buyer.description = value.description;
    },

    SET_BUYER_ENTITY_COMPLETE(state, value) {
      state.buyer.reference = value.reference;
      state.buyer.payType = value.payType;
      state.buyer.cellphone = value.cellphone;
    },
    SET_DATA_ENTITY(state, value) {
      state.data = value;
    },
    SET_REFERENCE(state, value) {
      state.buyer.description = value;
    }
  },
  actions: {
    setBuyerEntity(context, value) {
      context.commit("SET_BUYER_ENTITY", value);
    },
    saveDataEntity(context, value) {
      context.commit("SET_DATA_ENTITY", value);
    },

    saveDataEntityComplete(context, value) {
      context.commit("SET_BUYER_ENTITY_COMPLETE", value);
    },
    saveReference(context, value) {
      context.commit("SET_REFERENCE", value);
    },
    payService(context, value) {
      eventBus.$emit("openSpin", true);
      eventBus.$emit("openConfirmPay", {
        setPay: true,
        referencia: "Sys Factory"
      }); // emit the event to the bus
      // const data = {};
      const pLoad = {
        productCategoryUUID: value.productCategoryUUID,
        productCategoryName: value.productCategoryName,
        productUUID: value.productUUID,
        entityName: value.entityName,
        productName: value.productName,
        transactionAmount: value.amount,
        transactionDescription: context.getters.getDescriptionUnitel
          ? context.getters.getDescriptionUnitel
          : value.reference,
        paymentMethod: value.payType,
        transactionType: "Pagamento",
        targetEntityUUID: value.refOrigin,
        model: value.model,
        description: context.getters.getDescriptionUnitel
      };
      // alert(JSON.stringify(pLoad));
      apiServices
        .getPayService(pLoad)
        .then(function(response) {
          if (response.status === 200) {
            let obj = response.data;
            if (obj.code === 200) {
              let payload = {
                color: "success",
                text: "Operação realizada com sucesso!",
                errorLogin: true
              };
              eventBus.$emit("openInfo", payload); // emit the event to the bus
              context.commit("SET_REFERENCE", "");

              //apiServices.customizeHeader(token[1]);
              //router.push("/entity").catch(() => ({}));
              eventBus.$emit("openWpayment", false);
              eventBus.$emit("openPin", false);
            } else {
              let payload = {
                color: "error",
                text: "Ups! Verifique as suas credenciais",
                errorLogin: true
              };
              eventBus.$emit("openInfo", payload); // emit the event to the bus
            }
          } else {
            let payload = {
              color: "error",
              text: "Ups! Seu pedido não foi processado",
              errorLogin: true
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus
          }
        })
        .catch(function(error) {
          let payload = {
            color: "error",
            text: "Ups! Seu pedido não foi processado",
            errorLogin: true,
            right: "center"
          };
          if (error == "Error: Network Error")
            return eventBus.$emit("openInfo", {
              color: "error",
              text: "Verifique a sua conexão com a internet",
              errorLogin: true,
              right: "center"
            }); // emit the event to the bus
          eventBus.$emit("openInfo", payload); // emit the event to the bus
        })
        .finally(function() {
          eventBus.$emit("openSpin", false);
        });
    }
  },

  getters: {
    getEmailEntity(state) {
      return state.buyer.email;
    },
    getPosEntity(state) {
      return state.buyer.pos;
    },
    getEntity(state) {
      return state.buyer.entity;
    },
    getProduct(state) {
      return state.buyer.product;
    },
    getRefOrigin(state) {
      return state.buyer.refOrigin;
    },
    getReference(state) {
      return state.buyer.reference;
    },
    getPayType(state) {
      return state.buyer.payType;
    },

    getProductUUID(state) {
      return state.buyer.productUUID;
    },
    getProductCategoryName(state) {
      return state.buyer.productCategoryName;
    },

    getProductCategoryUUID(state) {
      return state.buyer.productCategoryUUID;
    },

    getRechargeCellphone(state) {
      return state.buyer.recharge;
    },
    getCellphoneH1(state) {
      return state.buyer.cellphone;
    },

    getPrice(state) {
      return state.buyer.price;
    },
    getData(state) {
      return state.data;
    },
    getDescriptionUnitel(state) {
      return state.buyer.description;
    }
  }
};
